export const ERRORS = {
  FAILED_TO_FETCH: 'Erro ao tentar buscar Regiões de Serviço'
};

export const LABELS = {
  required: 'Obrigatório',
  defaultOutputIdsField: 'originServiceRegionIds'
};
